module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/owners/css/owner-export.component.css
// module id = ./src/app/modules/owners/css/owner-export.component.css
// module chunks = main